export enum CrudAction {
    Create = 'create',
    Update = 'update'
}
